var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import CityItem from './cityitem';
var CityItemsModule = function (props) {
    var _a;
    var items = props.items, hasButton = props.hasButton, theme = props.theme;
    var _b = useState(true), isHidden = _b[0], setIsHidden = _b[1];
    var itemsCopied = __spreadArray([], items, true);
    if (items.length > 5) {
        itemsCopied.splice(5, items.length - 1);
    }
    var modulesCity = items.map(function (item, i) {
        var _a;
        return (React.createElement("div", { key: i, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { name: item.texts[1].textObject.name, isLast: i === items.length - 1, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor })));
    });
    var modulesCityReduced = itemsCopied.map(function (item, i) {
        var _a;
        return (React.createElement("div", { key: i, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { name: item.texts[1].textObject.name, isLast: i === items.length - 1, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor })));
    });
    return (React.createElement(React.Fragment, null,
        items.length > 5 && isHidden ? modulesCityReduced : modulesCity,
        items.length > 5 ? (React.createElement("div", { onClick: function () { return setIsHidden(!isHidden); }, style: { cursor: 'pointer' }, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { key: '-1', name: '...', isLast: true, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor }))) : ('')));
};
export default CityItemsModule;
//# sourceMappingURL=cityitemsblock.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import CityItem from './cityitem';
var CityItemsModule = function (props) {
    var _a;
    var items = props.items, hasButton = props.hasButton, theme = props.theme;
    var _b = useState(true), isHidden = _b[0], setIsHidden = _b[1];
    var itemsCopied = __spreadArray([], items, true);
    if (items.length > 5) {
        itemsCopied.splice(5, items.length - 1);
    }
    var modulesCity = items.map(function (item, i) {
        var _a;
        return (React.createElement("div", { key: i, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { name: item.texts[1].textObject.name, isLast: i === items.length - 1, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor })));
    });
    var modulesCityReduced = itemsCopied.map(function (item, i) {
        var _a;
        return (React.createElement("div", { key: i, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { name: item.texts[1].textObject.name, isLast: i === items.length - 1, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor })));
    });
    return (React.createElement(React.Fragment, null,
        items.length > 5 && isHidden ? modulesCityReduced : modulesCity,
        items.length > 5 ? (React.createElement("div", { onClick: function () { return setIsHidden(!isHidden); }, style: { cursor: 'pointer' }, className: 'offset-xl-6 offset-lg-6 col-xl-6 col-lg-6 col-12 spec-city-item-container' },
            React.createElement(CityItem, { key: '-1', name: '...', isLast: true, hasButton: hasButton, textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.cityItems) === null || _a === void 0 ? void 0 : _a.textColor }))) : ('')));
};
export default CityItemsModule;
//# sourceMappingURL=cityitemsblock.js.map